import { Component } from '@angular/core';

@Component({
  selector: 'app-family-landing',
  templateUrl: './family-landing.component.html',
  styleUrls: ['./family-landing.component.scss'],
  standalone: false,
})
export class FamilyLandingComponent {}
